import queryString from 'query-string';

export const pageFromQueryString = (searchString) => {
  const { page } = queryString.parse(searchString);
  return page;
};

export const pushPageToQueryString = (page, searchString) => {
  const parsed = queryString.parse(searchString);
  if (page > 1) {
    parsed.page = page;
  } else {
    delete parsed.page;
  }
  const stringified = queryString.stringify(parsed);
  return stringified;
};

// export const concatUrlString = (page) => {
//   let urlString;
//   if (page && page > 1) {
//     urlString = `page=${page}`;
//   }
//   return urlString;
// };

// export const queryStringFromProps = (props) => {
//   const { location } = props;
//   const queryObj = queryString.parse(location.search);
//   const { page } = queryObj;
//   if (page && page > 1) {
//     return `page=${page}`;
//   }
//   return null;
// };

// export const urlPushQuery = (listUrl, qString) => {
//   let url = listUrl;
//   if (qString) {
//     url = `${listUrl}?${qString}`;
//   }
//   return url;
// };
